require('./avatar.png');
require('./B-30-Metade.svg');
require('./b30-aponta-esquerda.png');
require('./b30-sem-resultado.png');
require('./img-semresultados.svg');
require('./empty/right-click.svg');